define('shared/initializer/form/adapters/mixins/upsell/Renderable',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
    'shared/util/state/adapters/offers',
    'shared/util/state/adapters/session',
    'shared/util/hub',
    'shared/initializer/die',
    'shared/remote/offer/get',
    'shared/page/language',
    'shared/page/wcmmode',
    'shared/lib/deepmerge'
], function (
    $,
    RSVP,
    state,
    persistentAdapter,
    offersAdapter,
    sessionAdapter,
    hub,
    die,
    getOffer,
    getLanguage,
    getWCMMode,
    deepmerge
) {
    'use strict';
    var DEBUG_KEY = 'persistent.debugger_upsell_offer_dummy_data';
    var SAMPLE = {
        'Id':2044,
        'MarketCode':'row',
        'OfferClassId':1,
        'Name':'Monthly Subscription (Basic Plan)',
        'NameBlurbId':25409,
        'CurrencyCode':'USD',
        'DisplayPrice':49,
        'Descr':'no mm,7FT,8GL Rest Middle East(L)$49',
        'InsertDate':'2008-05-09T07:56:37.12',
        'Campaign':{
            'Id':1825,
            'Name':'50%_ROW_Return',
            'DiscountBlurbId':158900,
            'Discounts':[{
                'Id':2383,'PhaseNumber':0,'IsPercent':true,'RepeatTimes':1,'IsRecurring':false,'Discount':50
            }]
        },
        'OfferType':'Subscription',
        'Phases':[{
            'Id':2076,
            'OfferId':2044,
            'PhaseNumber':0,
            'Price':49,
            'PhaseDuration':30,
            'PhaseDurationUnit':'Day',
            'PayDuration':30,
            'PayDurationUnit':'Day',
            'RepeatTimes':1,
            'IsRecurring':true,
            'InsertDate':'2008-05-09T07:56:37.167',
            'Features':[{
                'Id':3531,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':11,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':20,
                'InsertDate':'2008-05-09T07:56:37.167'
            },{
                'Id':3532,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':25,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':-1,
                'InsertDate':'2008-05-09T07:56:37.183'
            },{
                'Id':3533,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':33,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':-1,
                'InsertDate':'2008-05-09T07:56:37.183'
            },{
                'Id':12617,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':21,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':-1,
                'InsertDate':'2008-11-03T02:50:28.5'
            },{
                'Id':190619,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':27,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':1,
                'InsertDate':'2015-11-23T08:22:57.707'
            },{
                'Id':190620,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':28,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':1,
                'InsertDate':'2015-11-23T08:22:57.713'
            },{
                'Id':190621,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':29,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':1,
                'InsertDate':'2015-11-23T08:22:57.717'
            },{'Id':190622,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':30,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':1,
                'InsertDate':'2015-11-23T08:22:57.72'
            },{'Id':190623,
                'PaymentPlanPhaseId':2076,
                'FeatureAccessId':37,
                'Duration':30,
                'DurationUnit':'Day',
                'Quantity':2,
                'InsertDate':'2015-11-23T08:22:57.72'
            }]
        }]
    };

    function fixUpOfferData(offer) {
        if (!offer.CurrencyCode && offer.Currency) {
            offer.CurrencyCode = offer.Currency;
        }
        if (!offer.Id && offer.Offer_id) {
            offer.Id = offer.Offer_id;
        }
        // as it is upsell lets use phase 0 price as display price
        if (
            !offer.DisplayPrice && 
            offer.Phases && 
            offer.Phases.length > 0 &&
            offer.Phases[0].Price
        ) {
            offer.DisplayPrice = offer.Phases[0].Price;
        }
    }

    var formatters = {};
    function getFormatter(language, currencyCode) {
        if (formatters[language + '-' + currencyCode]) {
            return formatters[language + '-' + currencyCode];
        }
        formatters[language + '-' + currencyCode] = new Intl.NumberFormat(language, { style: 'currency', currency: currencyCode });
        return formatters[language + '-' + currencyCode];
    }

    function getDummyOffer(options) {
        var monoUnit = Math.random() * 10 < 5 ? true: false;
        var quantity = 1;
        var price = 34;
        if (!monoUnit) {
            quantity = Math.ceil(Math.random() * 10);
        }
        var ret = deepmerge({}, SAMPLE, {
            Id: options.id,
            Name: Math.random() * 10 < 5 ? 'Private Lessons': 'Group Lessons',
            DisplayPrice: quantity > 1 ? price * quantity * .9: price,
            CurrencyCode: 'USD'
        });

        if (quantity > 1) {
            ret.Phases[0].Features[0].Quantity = quantity;
        }
        else {
            ret.Phases[0].Features[0].Quantity = 1;
        }

        return RSVP.resolve(ret);
    }

    function Ctor () {
        var me = this;
        me.selectedOffers = [];
        me.promiseOfCurrency = new RSVP.Promise(function(rs){
            me.resolvePromiseOfCurrency = rs;
        });
        me.renderTotal = function () {
            var me = this;
            var offers = me.offers;
            var offer;
            var selectedOffers = me.selectedOffers;
            var sum = 0;
            var currencyCode;
            me.promiseOfCurrency.then(function(currencyCodeValue){
                currencyCode = currencyCodeValue;
                for(var l = selectedOffers.length;l--;) {
                    offer = offers[selectedOffers[l]];
                    if (!offer) {
                        continue;
                    }
                    sum += offer.DisplayPrice;
                }

                return getLanguage();
            })
            .then(function(language){
                var formatter = getFormatter(language, currencyCode);
                me.viewModel.total = formatter.format(sum);
                me.viewModel.sync();
            });
            
            
        };
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var $table = me.$form.find('> table.offers');
        var $tbody = $table.find('> tbody');
        var $trs = $tbody.find('> tr');
        var useDummyOffer = false;
        var language;
        var offers = me.offers;

        return RSVP.resolve()
            .then(function(){
                hub
                    .get('/debuglet/settings')
                    .then(function(settings){
                        settings['Dummy Offer'] = {
                            getValue: function() {
                                return new RSVP.Promise(function(resolve) {
                                    state
                                        .get(DEBUG_KEY)
                                        .then(function(values){
                                            resolve(values[0] && values[0].value || false);
                                        });
                                });
                            },
                            setValue: function(value) {
                                return new RSVP.Promise(function(resolve) {
                                    state
                                        .push(DEBUG_KEY, {value: value})
                                        .then(function(){
                                            resolve();
                                        });
                                });
                            }
                        };
                    });
            })
            .then(function(){
                return getLanguage();
            })
            .then(function(lng){
                language = lng;
            })
            .then(function(){
                return state.adapters.add(persistentAdapter);
            })
            .then(function(){
                return RSVP.all([state.get(DEBUG_KEY), getWCMMode()]);
            })
            .then(function(values){
                useDummyOffer = values[0][0] || values[1] === 'edit';
            })
            .then(function(){
                var promises = [];

                $trs.each(function(i){
                    var $tr = $trs.eq(i);
                    var offerId = $tr.attr('data-offer-id');

                    if (!offerId) {
                        return;
                    }

                    var promise;
                    
                    if (useDummyOffer) {
                        promise = getDummyOffer({
                            id: offerId
                        });
                    }
                    else {
                        promise = getOffer({
                            id: offerId
                        });
                    }

                    promise = promise.then(function(offer){
                        fixUpOfferData(offer);
                        if (offer.CurrencyCode && typeof me.resolvePromiseOfCurrency === 'function') {
                            me.resolvePromiseOfCurrency(offer.CurrencyCode);
                        }
                        var formatter = getFormatter(language, offer.CurrencyCode);
                        offer.FormattedPrice = formatter.format(offer.DisplayPrice);
                        offer.FormattedQuantity = offer.Phases && offer.Phases[0].Features[0].Quantity || 1;
                        offer.FormattedDescription = $tr.find('.description').text().trim();
                        offers[offer.Id] = offer;
                    });

                    promises.push(promise);
                });

                return RSVP.all(promises);
            })
            .then(function(){
                var draft = {};
                var key;
                var offer, name;
                // get unit price in following loop
                for (key in offers) {
                    if (!offers.hasOwnProperty(key)) {
                        continue;
                    }
                    offer = offers[key];
                    name = offer.Name;
                    if (!draft[name]) {
                        draft[name] = {};
                    }
                    if (offer.FormattedQuantity === 1) {
                        draft[name].price = offer.DisplayPrice;
                    }
                }

                // use the unit price to calculate the total without discount
                for (key in offers) {
                    if (!offers.hasOwnProperty(key)) {
                        continue;
                    }

                    offer = offers[key];
                    name = offer.Name;

                    if (offer.FormattedQuantity > 1) {
                        offers[key].Discount = Math.floor(draft[name].price * offer.FormattedQuantity - offer.DisplayPrice);
                    }
                }

                return;
            })
            .then(function(){
                return state.adapters.add(offersAdapter);
            })
            .then(function(){
                var promises = [];
                for (var key in offers) {
                    promises.push(state.push('offers.' + key, offers[key]));
                }
                return RSVP.all(promises);
            })
            .then(function(){
                var $texts = $table.find('.text');
                return die.init($texts)
                    .then(function(){
                        $texts.addClass('unmasked');
                    });
            });
    };

    return Ctor;
});
